// extracted by mini-css-extract-plugin
export default {"footer":"TableFooter_footer__0Z9CH","section":"TableFooter_section__JLhxm","text":"TableFooter_text__EZptd"};